import useStyles from "isomorphic-style-loader/useStyles";
import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useSelector, useStore } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { action_fetch_add_ticket_list, action_fetch_get_ticket_list } from "../../../../../store/actions/pages/customer";
import Header from "../../../../components/header";
import { Iconfont } from "../../../../components/icon/iconfont";
import { withList } from "../../../../components/list";
import { useApp } from "../../../../hooks/common";
import classes from './style.module.scss';

const TicketItem = props => {
    useStyles(classes)
    const {ticket, intl, history} = props

    const StatusBox = (status) => {
        // 加 已评价状态为 灰色
        // 加 等待评价为 黄色
        switch(status){
            case 2:
                return (<div>
                            <span className={classes.StatusCircle}></span>
                            <span className={classes.StatusTxt}>{intl.formatMessage({id:'status_replied'})}</span>
                        </div>)
            case 1:
                return (<div className={classes.Waiting}>
                            <span className={classes.StatusCircle} style={{backgroundColor:'#f9a646'}}></span>
                            <span className={classes.StatusTxt} style={{color:'#f9a646'}}>{intl.formatMessage({id:'status_wating'})}</span>
                        </div>)
            
            case 3:
                return (<div className={classes.Resolved}>
                            <span className={classes.StatusCircle} style={{backgroundColor:'#999'}}></span>
                            <span className={classes.StatusTxt} style={{color:'#999'}}>{intl.formatMessage({id:'status_resolved'})}</span>
                        </div>)
            default:
                return (<div className={classes.Resolved}>
                            <span className={classes.StatusCircle} style={{backgroundColor:'#E64646'}}></span>
                            <span className={classes.StatusTxt} style={{color:'#E64646'}}>{intl.formatMessage({id:'status_wating_apply'})}</span>
                        </div>)
        }
    }

    const link = (item) => {
        if(item?.id){
            history.push({pathname:`/user/faq/support-ticket`, state:{id: item.id}})
        }
    }

    const formateMsg = useMemo(() => {
        return ticket.ticketReplies && ticket.ticketReplies.length > 0 &&
            ticket.ticketReplies.slice(-1)[ticket.ticketReplies.slice(-1).length - 1]?.message ?
            ticket.ticketReplies.slice(-1)[ticket.ticketReplies.slice(-1).length - 1]?.messageType == 1 ?
            intl.formatMessage({id: 'retrun_the_order', defaultMessage: 'Return the Order'}):
            ticket.ticketReplies.slice(-1)[ticket.ticketReplies.slice(-1).length - 1]?.message : '-'
    }, [ticket])

    return (
        <div className={classes.TicketItemBox} onClick={()=>link(ticket)}>
            <div className={classes.TicketLineOne}>
                <div style={{display:'flex'}}>
                    {intl.formatMessage({id:'ticket_id'})}
                </div>
                <span className={classes.TicketId}>{ticket.id}</span>
                <div className={classes.ticket_time}>
                    {new Date(ticket.openDate).toLocaleDateString()}
                </div>
            </div>
            <div className={classes.TicketContent}>
                {formateMsg}
            </div>
            {
                StatusBox(ticket.state)
            }
        </div>
    )
}

const TicketEmpty = props => {
    useStyles(classes)
    const {intl} = props

    return (
        <div className={classes.NoDataBox}>
            <Iconfont className={classes.NoDataImg}>&#xe7c6;</Iconfont>
            <span className={classes.NoDataTxt}>{intl.formatMessage({id: 'noTicket'})}</span>
        </div>
    )
}

const TicketListBox = withList(props => {
    useStyles(classes)
    const {tickets, intl, history} = props
    return (
        <div className={classes.TicketListBox}>
            {
                tickets?.map((item, index) => (
                    <TicketItem ticket={item} key={index} intl={intl} history={history}/>
                ))
            }
        </div>
    )
})

const SubmitButton = props => {
    useStyles(classes)
    const {intl, history, isApp} = props
    const bottomPx = (px) =>  `${2 * px / 75 * 1}rem`;

    return(
        <div className={classes.SubmitBtn} style={{bottom: isApp ? '0': bottomPx(74)}}>
            <span onClick={() => history.push({pathname:`/user/support/order`,state:{from:'ticket'}})}>
                {intl.formatMessage({id: 'submit'})}
            </span>
        </div>
    )
}

const TicketList = props => {
    useStyles(classes)
    const Intl = useIntl()
    const {customer, ticketList} = useSelector(state => state.pageCustomer)
    const store = useStore()
    const history = useHistory()
    const isApp = useApp()
    const dispatch = useDispatch()
    const {pathname} = useLocation()
    const [showVip, setShowVip] = useState(false)


    useEffect(async () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        // document.body.style.background = "#f6f6f6"
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            // console.log(ticketList)
            // if(ticketList?.data?.length < 1){
            await TicketList.fetchData(store, null, null)
            // }
		}
        if(window.zE){
            window.zE('webWidget', 'hide');
        }

        return (() => {
            // document.body.style.background = ''
        })
    }, [])

    useEffect(() => {
        if(pathname.indexOf("ticket-vip") != -1){
            setShowVip(true)
        }
    }, [pathname])

    const onScroll = async () => {
       await dispatch(action_fetch_add_ticket_list(ticketList?.skip || 0))
    }

    return (
        <div className={classes.TicketList}>
            <Header
                centerSlot={
                    showVip?
                    <span style={{color:'#DDC35E'}}>
                        <Iconfont style={{marginRight: 5}}>&#xe783;</Iconfont>
                        {Intl.formatMessage({ id: "vip_service", defaultMessage: "VIP service" })}
                    </span>:
                    Intl.formatMessage({ id: "ticket", defaultMessage: "Ticket" })
                }/>

            {
                ticketList?.data?.length > 0 ?
                <TicketListBox
                    tickets={ticketList?.data || []}
                    intl={Intl}
                    history={history}
                    request={onScroll}
                    loading={ticketList?.loading}
                    finished={ticketList?.finished}
                    />:
                <TicketEmpty intl={Intl}/>
            }

            <SubmitButton isApp={isApp} intl={Intl} history={history}/>

        </div>
    )
}

TicketList.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_get_ticket_list(0,headers));
}

export default TicketList